import { CmsSubscriptionService } from "./cms-subscription.service";

export const cmsSubscriptionService = new CmsSubscriptionService();
